import { useEffect } from 'react';
import { hotjar } from 'react-hotjar';
import { AuthStatus, useAuth } from '../../auth';
import { useConfig, useSwitchAwareConfig } from '../use-config';
import { flattenTags, prefixLabels } from './tracking.utils';

export const useHotjar = (): void => {
  const { hotjar: hotjarConfig } = useConfig();
  const { productName } = useSwitchAwareConfig();
  const { state } = useAuth();

  useEffect(() => {
    if (!hotjarConfig || !hotjarConfig.hotjarId || !hotjarConfig.scriptVersion) return;

    hotjar.initialize({ id: Number(hotjarConfig.hotjarId), sv: Number(hotjarConfig.scriptVersion), debug: !import.meta.env.PROD });
  }, [hotjarConfig]);

  useEffect(() => {
    if (!state || state.status !== AuthStatus.AUTHENTICATED) return;

    const { account, user } = state;

    if (!hotjar.initialized()) return;

    hotjar.identify(user._id, {
      'email': user.email,
      'name': user.display,
      'home_domain': account.homeDomain,
      'product': productName,
      ...flattenTags(user.tags, 'user_tag'),
      ...prefixLabels(user.labels, 'user_label'),
      'account_id': account._id,
      'account_name': account.display,
      ...flattenTags(account.tags, 'account_tag'),
      ...prefixLabels(account.labels, 'account_label'),
    });
  }, [hotjarConfig, productName, state]);
};
